import  { Mail, Phone, MapPin } from 'lucide-react';

const ContactPage = () => {
  return (
    <div className="pt-24 pb-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="font-serif text-4xl mb-2">Contact Us</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We'd love to hear from you. Reach out with any questions about our collections, 
            custom designs, or to schedule an appointment.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div className="bg-beige-light p-8">
            <h2 className="font-serif text-2xl mb-8">Send Us a Message</h2>
            <form className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input
                  type="text"
                  id="name"
                  className="w-full p-3 border border-gray-300 focus:border-gold focus:ring-0 outline-none"
                  placeholder="Your name"
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  id="email"
                  className="w-full p-3 border border-gray-300 focus:border-gold focus:ring-0 outline-none"
                  placeholder="Your email"
                />
              </div>
              
              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                <input
                  type="text"
                  id="subject"
                  className="w-full p-3 border border-gray-300 focus:border-gold focus:ring-0 outline-none"
                  placeholder="Subject"
                />
              </div>
              
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <textarea
                  id="message"
                  rows={5}
                  className="w-full p-3 border border-gray-300 focus:border-gold focus:ring-0 outline-none"
                  placeholder="Your message"
                />
              </div>
              
              <div>
                <button
                  type="submit"
                  className="w-full bg-gold hover:bg-gold-dark text-white px-8 py-3 uppercase tracking-wide text-sm transition-colors duration-300"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
          
          <div>
            <h2 className="font-serif text-2xl mb-8">Contact Information</h2>
            <div className="space-y-8">
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-4">
                  <MapPin className="text-gold" size={24} />
                </div>
                <div>
                  <h3 className="font-medium mb-2">Visit Our Store</h3>
                  <address className="not-italic text-gray-600">
                    <p>500 Fifth Avenue</p>
                    <p>New York, NY 10110</p>
                    <p>United States</p>
                  </address>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-4">
                  <Mail className="text-gold" size={24} />
                </div>
                <div>
                  <h3 className="font-medium mb-2">Email Us</h3>
                  <p className="text-gray-600">hello@lustreandco.com</p>
                  <p className="text-gray-600">customer.care@lustreandco.com</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-4">
                  <Phone className="text-gold" size={24} />
                </div>
                <div>
                  <h3 className="font-medium mb-2">Call Us</h3>
                  <p className="text-gray-600">+1 (212) 555-0198</p>
                  <p className="text-gray-600">Mon-Fri, 10am-6pm EST</p>
                </div>
              </div>
            </div>
            
            {/* Opening Hours */}
            <div className="bg-white p-8 rounded-xl shadow-sm mt-12">
              <h3 className="text-xl font-serif text-gray-900 mb-6">Opening Hours</h3>
              <div className="space-y-4">
                {[
                  { day: 'Monday - Friday', hours: '10:00 AM - 7:00 PM' },
                  { day: 'Saturday', hours: '10:00 AM - 6:00 PM' },
                  { day: 'Sunday', hours: '11:00 AM - 5:00 PM' }
                ].map((schedule) => (
                  <div key={schedule.day} className="flex justify-between items-center py-2 border-b border-gray-100 last:border-0">
                    <span className="text-gray-600">{schedule.day}</span>
                    <span className="font-medium text-gray-900">{schedule.hours}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        <div className="h-96 mb-8">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.2884922842503!2d-73.98323368459367!3d40.75420397932764!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9aeb1c6b5%3A0x35b1cfbc89a6097f!2s500%205th%20Ave%2C%20New%20York%2C%20NY%2010110%2C%20USA!5e0!3m2!1sen!2sca!4v1623181429166!5m2!1sen!2sca" 
            width="100%" 
            height="100%" 
            style={{ border: 0 }} 
            allowFullScreen 
            loading="lazy" 
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
 